import { render, staticRenderFns } from "./CobranzaSeguroHospitalizacion.vue?vue&type=template&id=a7f24e30"
import script from "./CobranzaSeguroHospitalizacion.vue?vue&type=script&lang=js"
export * from "./CobranzaSeguroHospitalizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports